import { FieldTitle } from './RedStarTitle';
import Select from 'react-select';
import * as React from 'react';
import { toImgSrc } from './helpers';
import { Controller, useFormContext } from 'react-hook-form';
import { FieldDesc } from './common';
import { TextField } from '@client/new/components/basic';
import { TwoColumns } from './layouts';

type Props = {
  index: number;
  programs: Array<{
    id: number;
    name?: string;
    accessType: string;
    mediaCover?: {
      image?: string;
      cdn01?: string;
    };
  }>;
  influencerId: number;
};
export function ProgramsCarousel({ index, programs, influencerId }: Props) {
  const { register, control, watch } = useFormContext();
  const r = (s) => register(`sections.${index}.${s}`);
  const state = watch(`sections.${index}`);

  const options = programs.map((program) => ({
    value: program.id,
    label: (
      <div className="flex items-center">
        <img
          src={toImgSrc(program.mediaCover)}
          style={{
            maxHeight: '60px',
            borderRadius: '4px',
            marginRight: '10px',
          }}
        />
        {program.name}
      </div>
    ),
  }));

  const selectedPrograms = state.programIds?.length
    ? programs.filter((p) => (state.programIds || []).includes(p.id))
    : programs;

  // render:

  const firstCol = (
    <>
      <div>
        <FieldTitle title={'Headline text'} />
        <TextField
          {...r(`title`)}
          className="mb-[5px] max-w-[680px] w-full"
          inputProps={{
            placeholder: 'Headline text',
            maxLength: 60,
          }}
        />
      </div>

      <div>
        <FieldTitle title={'Subtitle'} optional />
        <TextField
          {...r(`subtitle`)}
          className="mb-[5px] max-w-[680px] w-full"
          inputProps={{
            placeholder: 'Headline text',
            maxLength: 60,
          }}
        />
      </div>
    </>
  );

  const secondCol = (
    <>
      <div>
        <FieldTitle title={'Choose programs'} optional />
        <FieldDesc>
          Will be displayed in order selected. By default all programs are
          displayed.
        </FieldDesc>
        <Controller
          name={`sections.${index}.programIds`}
          control={control}
          render={({ field: { value, onChange, ref } }) => (
            <Select
              ref={ref}
              isMulti
              options={options}
              value={options.filter((o) => (value || []).includes(o.value))}
              onChange={(options) => onChange(options.map((o) => o.value))}
              styles={{
                control: (provided) => ({
                  ...provided,
                  minHeight: '56px',
                }),
              }}
            />
          )}
        />
      </div>

      <ProgramCards programs={selectedPrograms} influencerId={influencerId} />
    </>
  );

  return <TwoColumns first={firstCol} second={secondCol} />;
}

export function ProgramCards({
  programs,
  influencerId,
}: {
  programs: Props['programs'];
  influencerId: number;
}) {
  return (
    <div>
      <div className="mb-4">Click to edit cover image:</div>
      <div className="flex flex-wrap gap-2.5">
        {programs.map((p) => (
          <ProgramCard program={p} key={p.id} influencerId={influencerId} />
        ))}
      </div>
    </div>
  );
}

function ProgramCard({
  program,
  influencerId,
}: {
  program: {
    id: number;
    name?: string;
    mediaCover?: unknown;
  };
  influencerId: number;
}) {
  return (
    <div key={program.id}>
      <a
        target="_blank"
        rel="noreferrer"
        href={`/admin/${influencerId}/program/${program.id}/edit`}
      >
        <img
          src={toImgSrc(program.mediaCover)}
          style={{
            width: '60px',
            height: '60px',
            maxHeight: '60px',
            borderRadius: '4px',
            objectFit: 'cover',
          }}
        />
      </a>
    </div>
  );
}
